import * as React from "react";
import Alert from "@cloudscape-design/components/alert";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { ContentGrid } from "@amzn/awsmp-max-ux-patterns/ContentGrid";
import { useBrowserDetection } from "./useBrowserDetection";
import { useBrowserWarningStore } from "./browserWarningStore";

/**
 * Browser compatibility warning banner.
 *
 * Shows a dismissible translated warning when user's browser is not supported.
 * Uses Zustand store for dismissal state persistence.
 * Uses react-i18next for translations (matches MAX architecture).
 *
 * Translation keys:
 * - browserNotSupportedHeader
 * - browserNotSupportedDescription
 *
 * Usage:
 * <BrowserCompatibilityWarning />
 *
 * No props needed - manages state internally with Zustand.
 */
export const BrowserCompatibilityWarning: React.FC = () => {
  const { t } = useAppTranslation();
  const { isSupported } = useBrowserDetection();
  const { dismissed, dismiss } = useBrowserWarningStore();

  // Don't show if supported or dismissed
  if (isSupported || dismissed) {
    return null;
  }

  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <ContentGrid>
        <Alert type="warning" dismissible={true} onDismiss={dismiss} header={t("browserNotSupportedHeader")}>
          {t("browserNotSupportedDescription")}
        </Alert>
      </ContentGrid>
    </div>
  );
};
